import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { node, string } from 'prop-types';
import { ContainerLabel } from './dropdown.styles';

const DropdownLabel = _ref => {
  let {
    children,
    startIcon,
    endIcon
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "startIcon", "endIcon"]);

  return /*#__PURE__*/React.createElement(ContainerLabel, props, startIcon, children, endIcon);
};

process.env.NODE_ENV !== "production" ? DropdownLabel.propTypes = {
  children: node,
  startIcon: node,
  endIcon: node,
  forwardedAs: string
} : void 0;
DropdownLabel.defaultProps = {
  children: null,
  startIcon: null,
  endIcon: null,
  forwardedAs: 'li'
};
DropdownLabel.displayName = 'DropdownLabel';
export default DropdownLabel;